@if (documents?.length > 0) {
  <sd-component-wrapper
    id="IfuListComponent_{{pageTemplate.charAt(0).toUpperCase() + pageTemplate.slice(1).toLowerCase()}}Page_1"
    [content]="wrapperContent"
    [themesConfig]="lameConfig?.backgroundTheme"
    [brand]="brand"
  >
    <sd-documents sd-component-wrapper-component
      [documents]="documents"
      [titleLevel]="3"
      [pushTemplate]="push"
      [brand]="brand"
      (downloadedDocument)="onClick($event)"
    />
  </sd-component-wrapper>
}

<ng-template #pushTemplate>
  <sd-push-card
    [pushSize]="pushSizeEnum.m"
    [textConfig]="pushCardTextConfig"
    [mediaConfig]="pushCardMediaConfig"
    [push]="pushCardData"
    [imageRatio]="pushCardImageRatio"
    [titleLevel]="1"
    [themesConfig]="pushCardThemeConfig"
    [mediaAsBackground]="pushCardMediaAsBackground"
    [brand]="brand"
  />
</ng-template>
